import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Product.Details.IRequest;
type Response = Api.Core.Product.Details.IResponse;
type Headers = Api.Core.Product.Details.IHeaders;
const url = '/api/ProductManagement/Product/ProductsForVehicle/:vehicleModelId/:vehiclePurchasePrice';
export default async function productDetailsApi(params?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
    tryParse: true,
  });
}
